import { useRootStore } from 'contexts/RootStore.context';
import { Location } from 'types/venue';

export default function AccuracyRangeSpan({ location }: { location?: Location }) {

  const { getUncertaintyValue } = useRootStore();
  const accuracyRangeString = getUncertaintyValue(location?.uncertainty)
  return <span>{accuracyRangeString}</span>;
}
